import { TextField } from "@mui/material";
import { css, styled } from "@mui/material/styles";

const StyledTextField = styled(TextField)(({ dark }: { dark: number }) => {
  if (dark) {
    return css`
      fieldset {
        border: none;
      }

      & .MuiSvgIcon-root {
        color: black;
      }
    `;
  }

  return css`
    padding: 8px 12px;

    fieldset {
      border: 1.5px solid #e8edf3;
    }

    & .MuiInputBase-root {
      width: 220px;
      height: 40px;
      background: #f8fafc;

      &:hover fieldset {
        border: 1.5px solid #e8edf3;
      }

      &.Mui-focused .MuiOutlinedInput-notchedOutline {
        border: 2px solid #237ac3;
      }
    }

    & .MuiSvgIcon-root {
      color: black;
    }
  `;
});

export default StyledTextField;
